import React, { useState } from 'react';
import TopNav from '../../../Components/TopNav';
import Navbar from '../../../Components/Navbar';
import DropdownNav from '../../../Components/DropdownNav';
import './about.css'
import Footer from '../../../Components/Footer';
import Example from '../../../Components/Example';
import ScrollToTop from 'react-scroll-to-top';

const NIRF_About = () => {
  const [toggle, setToggle] = useState(1)

  function updateToogle(id) {
    setToggle(id)
  }
  return (
    <div>
      <Example />
      <ScrollToTop smooth top="1000" />
      <div className='navbar-area'>
        <div className='init-image'>
          <div className='image-cover'>

          </div>
        </div>
      </div>

      <div className='Measi-details'>
        <div className='measi-header'>
          <h2>Infrastructure → NIRF</h2>
          <p>The New College infrastructure is one of the biggest & best in Tamil Nadu.</p>
        </div>

        <div className='tab-main'>
          <ul className='tab-details'>
            <li className={toggle === 1 ? "show-tab-title" : 'tab-title'} onClick={() => updateToogle(1)}>NIRF_About</li>
          </ul>


          {/* Tab One Details */}

          <div className={toggle === 1 ? "show-tab-content" : 'tab-content'}>
            <div className='ssr-items'>
              {/* This is the starting node of AQARREPORTS */}

              <div>
                <div className='aqar-items'>
                  <a href='https://thenewcollege.edu.in/pdf/NIRF%202017%20-%202018.pdf' target='new'>
                    <img src='https://sedge.in/New%20College/assest/logo.png' className='ssr-image' />
                    <h3>2017 - 2018 <br></br>NIRF Report</h3>
                  </a>
                </div>
              </div>
              <div>
                <div className='aqar-items'>
                  <a href='https://thenewcollege.edu.in/pdf/NIRF%202018%20-%202019.pdf' target='new'>
                    <img src='https://sedge.in/New%20College/assest/logo.png' className='ssr-image' />
                    <h3>2018 - 2019 <br></br>NIRF Report</h3>
                  </a>
                </div>
              </div>
              <div>
                <div className='aqar-items'>
                  <a href='https://thenewcollege.edu.in/pdf/NIRF%202019%20-%202020.pdf' target='new'>
                    <img src='https://sedge.in/New%20College/assest/logo.png' className='ssr-image' />
                    <h3>2019 - 2020 <br></br>NIRF Report</h3>
                  </a>
                </div>
              </div>
              <div>
                <div className='aqar-items'>
                  <a href='https://thenewcollege.edu.in/pdf/NIRF2020-2021.pdf' target='new'>
                    <img src='https://sedge.in/New%20College/assest/logo.png' className='ssr-image' />
                    <h3>2020 - 2021 <br></br>NIRF Report</h3>
                  </a>
                </div>
              </div>
              <div>
                <div className='aqar-items'>
                  <a href='https://thenewcollege.edu.in/pdf/NIRF%20Report%202021.pdf' target='new'>
                    <img src='https://sedge.in/New%20College/assest/logo.png' className='ssr-image' />
                    <h3>2021 - 2022 <br></br>NIRF Report</h3>
                  </a>
                </div>
              </div>
              <div>
                <div className='aqar-items'>
                  <a href='https://thenewcollege.edu.in/pdf/NIRF2023.pdf' target='new'>
                    <img src='https://sedge.in/New%20College/assest/logo.png' className='ssr-image' />
                    <h3>2022 - 2023 <br></br>NIRF Report</h3>
                  </a>
                </div>
              </div>
              <div>
                <div className='aqar-items'>
                  <a href='https://thenewcollege.edu.in/pdf/NIRF2024.pdf' target='new'>
                    <img src='https://sedge.in/New%20College/assest/logo.png' className='ssr-image' />
                    <h3>2023 - 2024 <br></br>NIRF Report</h3>
                  </a>
                </div>
              </div>

            </div>
          </div>

        </div>
      </div>

      <Footer />
    </div>
  );
}

export default NIRF_About;
